import { render } from "./ModalSuccessMessage.vue?vue&type=template&id=c66e2b3e&scoped=true"
import script from "./ModalSuccessMessage.vue?vue&type=script&lang=js"
export * from "./ModalSuccessMessage.vue?vue&type=script&lang=js"

import "./ModalSuccessMessage.vue?vue&type=style&index=0&id=c66e2b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66e2b3e"]])

export default __exports__